import { useCdnImg } from '@webplatform/cdn-image';

export function getOptimizedImage(src: string, modifiers = {}): string {
  if (!src) return '';

  const { generateUrl } = useCdnImg();

  return generateUrl(src, modifiers);
}
